import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './ImagePicker.scss';
import Cropper from 'react-cropper';
import 'cropperjs/dist/cropper.css';// eslint-disable-line import/no-extraneous-dependencies
import { DismissButton ,SuccessButton } from '../../index';
import rotateIcon from '../../assets/imgs/Icon-Rotate-01.svg';
import zoomInIcon from '../../assets/imgs/icon-ZoomIn.png';
import zoomOutIcon from '../../assets/imgs/icon-ZoomOut.png';

/* eslint-disable react/no-string-refs */
class ImagePicker extends Component {
  static propTypes = {
    aspectRatio: PropTypes.any,
    isRound: PropTypes.bool,
    cropperStyle: PropTypes.object
  };

  static defaultProps = {
    aspectRatio: 1/1,
    isRound: true,
    cropperStyle:{
      height: 315,
      width: 560,
    }
  };


  cropper = this.cropper

  shouldComponentUpdate(prevProps) {
    if (prevProps.img !== this.props.img) {
      return true;
    }
    return false;
  }

  handleSave = ()=> {
    const { handleSave } = this.props
    handleSave(this.cropper.getCroppedCanvas().toDataURL())
  };

  handleRotate = () => {
    this.cropper.rotate(90);
  }

  handleZoomIn = () => {
    this.cropper.zoom(0.1);
  }

  handleZoomOut = () => {
    this.cropper.zoom(-0.1);
  }

  render() {
    const { img, handleCancel, aspectRatio, isRound , cropperStyle} = this.props;
    return (
        <div className={isRound ? "image-picker" : "image-picker image-picker--not-round" } data-testid='cropper-save'>
          <Cropper
            ref={ref => {this.cropper = ref}}
            src={img}
            style={cropperStyle}
            dragMode='crop'
            aspectRatio={aspectRatio}
            guides={false}
            autoCropArea={1}
          />
          <div className="image-picker__cropper-buttons">
            <button style={{ all: 'unset' }} type="button" onClick={this.handleRotate}>
              <img src={rotateIcon} className="image-picker__cropper-buttons__button" alt=''/>
            </button>
            <div>
            <button style={{ all: 'unset' }} type="button" onClick={this.handleZoomIn}>
              <img src={zoomInIcon} className="image-picker__cropper-buttons__button" alt=''/>
            </button>
            <button style={{ all: 'unset' }} type="button" onClick={this.handleZoomOut}>
              <img src={zoomOutIcon} className="image-picker__cropper-buttons__button" alt=''/>
            </button>
            </div>

          </div>
          <div className="image-picker__buttons">
            <SuccessButton onClick={this.handleSave} >SAVE</SuccessButton>
            <DismissButton onClick={handleCancel}>CANCEL</DismissButton>
          </div>
        </div>
    )
  };
};

export default ImagePicker;
